import React, {Component} from 'react';
import './AvailableFtoCard.scss';
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class AvailableFtoCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openedFTOAssignments: false,
    };
  }

  toggleFTOAssignments() {
    this.setState({
      openedFTOAssignments: !this.state.openedFTOAssignments,
    });
  }

  render() {
    return (
      <div className="available-fto-card">
        <div className="fto-content">
          <div className="fto-info">
            <div className="fto-name">{this.props.fto.getFullName()}</div>
            <div className="fto-tel">
              <i className="fa fa-phone" />
              {this.props.fto.getDefaultPhone()}
            </div>
          </div>
          <div className="fto-actions">
            {(this.props.fto.currentTrainingPhases.length === 0)
              ? <span className="badge badge-success">Available</span>
              : (
                <button
                  className="button small"
                  onClick={() => this.toggleFTOAssignments()}>
                  View assignments
                </button>
              )
            }

            <button
              className="button primary small"
              onClick={() => this.props.onAssign(this.props.fto.guid)}
            >
              Assign
            </button>
          </div>
        </div>
        {this.state.openedFTOAssignments && (
          <div className="fto-assignments">
            {this.props.fto.currentTrainingPhases.length === 0 ? (
              <h3>No assignments found</h3>
            ) : (
              this.props.fto.currentTrainingPhases.map((phase, index) => (
                <div className="fto-assignment" key={parseInt(index, 10)}>
                  <div>{this.props.oitShortLabel}: {`${phase.oit.firstName} ${phase.oit.lastName}`}</div>
                  <div className="badge badge-secondary">{phase.header}</div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state)
  }
};

export default connect(mapStateToProps)(AvailableFtoCard);
